import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5eb636c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "status-container"
}
const _hoisted_2 = { class: "status-item" }
const _hoisted_3 = { class: "gordita-400-11 status-text" }
const _hoisted_4 = { class: "gordita-400-11-m" }
const _hoisted_5 = {
  key: 0,
  class: "status-item"
}
const _hoisted_6 = { class: "gordita-400-11 status-text" }
const _hoisted_7 = { class: "gordita-400-11-m" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" is ")
const _hoisted_9 = { class: "gordita-400-11-m status-text-append" }
const _hoisted_10 = {
  key: 1,
  class: "status-item backups-block"
}
const _hoisted_11 = { class: "gordita-400-11 status-text" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" are ")
const _hoisted_13 = { class: "gordita-400-11-m status-text-append" }

import { computed, inject, ref } from 'vue';
import { IncrediLegend } from 'incredi-ui';
import { useAgentsPageQuery } from '@/graphql/codegen/generated/graphql';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { useOsService } from '@/services/OsService/OsService';
import { BackupCoordinatorStatus } from './backupStatus.types';
import {
  getPrimaryCoordinatorTextAppend,
  getTooltipTitle,
  getTooltipWidth,
  getTooltipAnchor,
  getBulletColorNamePrimary,
  getBulletColorNameBackup,
  getBackupCoordinatorTextAppend,
  STATUS_COLOR_MAP,
} from './backupStatusBar.helpers';
import TooltipBtn from '../TooltipBtn.vue';
import TooltipWithShowMoreOption from '../TooltipWithShowMoreOption.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'backupStatusBar',
  setup(__props, { expose }) {

const coordinatorsService = inject(IKCoordinatorsService);
const osService = useOsService();

const backupData = useAgentsPageQuery(() => ({ coordinatorId: coordinatorsService?.selectedCoordinator.value || '' }));

const isAnyBackupInstalled = computed(() => {
  const backupsNames = backupData.result.value?.ibManagerEntities?.settings?.common?.backup?.backupCoordinatorNames || [];
  const backupsHosts = backupData.result.value?.ibManagerEntities?.settings?.common?.backup?.backupCoordinatorHosts || [];
  const otherCoordinatorHost = backupData.result.value?.ibManagerEntities?.settings?.common?.backup?.otherCoordinatorHost;
  const otherCoordinatorName = backupData.result.value?.ibManagerEntities?.settings?.common?.backup?.otherCoordinatorName;
  if (osService?.isUnix) {
    return !!(otherCoordinatorHost || otherCoordinatorName);
  }
  return backupsNames.length > 0 || backupsHosts.length > 0;
});

expose({
  isAnyBackupInstalled,
});

const config = ref({ showBackupsTooltip: false });
const maxBackupItems: number = 5;

const clickHandler = (event: Event) => {
  event.stopPropagation();
  config.value.showBackupsTooltip = true;
};
const chosenBackupCoordinator = computed(
  () => backupData.result.value?.ibManagerEntities?.settings?.common?.backup?.otherCoordinatorName || backupData.result.value?.ibManagerEntities?.settings?.common?.backup?.otherCoordinatorHost,
);

const isBackupCoordinatorConfigured = computed(() => !!chosenBackupCoordinator.value);
const isBackupCoordinatorOnline = computed(() => backupData.result.value?.ibManagerEntities?.settings?.common?.backup?.isOnline);
// incompatible status is only for Windows, inLinux is always true
const isBackupCoordinatorHasSameVersion = computed(() => osService?.isUnix.value || backupData.result.value?.ibManagerEntities?.settings?.common?.backup?.isSameVersion);

const backupStatus = computed(() => {
  if (!isBackupCoordinatorConfigured.value) return BackupCoordinatorStatus.NotConfigured;
  if (!isBackupCoordinatorHasSameVersion.value) return BackupCoordinatorStatus.Incompatible;
  return isBackupCoordinatorOnline.value ? BackupCoordinatorStatus.StandBy : BackupCoordinatorStatus.Down;
});
const showChosenBackupTooltip = computed(
  () => backupStatus.value === BackupCoordinatorStatus.Down || backupStatus.value === BackupCoordinatorStatus.Incompatible || backupStatus.value === BackupCoordinatorStatus.NotConfigured,
);

const installedBackupNamesWithoutSelectedBackup = computed(() => {
  const backupCoordinatorNames = backupData.result.value?.ibManagerEntities?.settings?.common?.backup?.backupCoordinatorNames || '';
  const selectedBackupName = backupData.result.value?.ibManagerEntities?.settings?.common?.backup?.otherCoordinatorName;
  const machinesNames = [...backupCoordinatorNames.split(',')];
  return machinesNames.filter((item: string) => item !== selectedBackupName);
});
const shouldShowBackupCoordinators = computed(() => osService?.isWindows.value && installedBackupNamesWithoutSelectedBackup.value.length > 0);
const showBackupStatus = computed(() => isBackupCoordinatorConfigured.value || (!isBackupCoordinatorConfigured.value && !shouldShowBackupCoordinators.value));
const showPostfixSeparator = computed(() => osService?.isUnix.value);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(isAnyBackupInstalled))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(IncrediLegend), {
              color: _unref(getBulletColorNamePrimary)(),
              class: "bullet",
              size: 8
            }, null, 8, ["color"]),
            _createElementVNode("div", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.$t(`generic.backupCoordinator.coordinatorType.primary`) + ' is') + " ", 1),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(getPrimaryCoordinatorTextAppend)(_unref(backupStatus))), 1)
            ])
          ]),
          (_unref(showBackupStatus))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_unref(IncrediLegend), {
                  color: _unref(getBulletColorNameBackup)(_unref(backupStatus)),
                  class: _normalizeClass(["bullet", { 'bullet--bordered': _unref(backupStatus) === _unref(BackupCoordinatorStatus).Down }]),
                  size: 8
                }, null, 8, ["color", "class"]),
                _createElementVNode("div", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_unref(osService)?.isWindows.value ? _ctx.$t('generic.backupCoordinator.coordinatorType.configuredBackup.windows') : _ctx.$t('generic.backupCoordinator.coordinatorType.configuredBackup.linux')) + " ", 1),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(chosenBackupCoordinator)), 1),
                  _hoisted_8,
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(getBackupCoordinatorTextAppend)(_unref(backupStatus))), 1)
                ]),
                (_unref(showChosenBackupTooltip))
                  ? (_openBlock(), _createBlock(TooltipBtn, {
                      key: 0,
                      "tooltip-width": _unref(getTooltipWidth)(_unref(backupStatus)),
                      "btn-size": 7,
                      "self-anchor": _unref(getTooltipAnchor)(_unref(backupStatus)),
                      "tooltip-body-text-class": "ib-color-white",
                      "btn-icon": "icon-question-circle",
                      "tooltip-body-text": _unref(getTooltipTitle)(_unref(backupStatus))
                    }, null, 8, ["tooltip-width", "self-anchor", "tooltip-body-text"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_unref(shouldShowBackupCoordinators))
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_unref(IncrediLegend), {
                  color: _unref(STATUS_COLOR_MAP).Yellow,
                  class: "bullet",
                  size: 8
                }, null, 8, ["color"]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", {
                    class: "backups",
                    onClick: clickHandler
                  }, _toDisplayString(_ctx.$t(`generic.backupCoordinator.coordinatorType.backups`, [_unref(installedBackupNamesWithoutSelectedBackup).length])), 1),
                  _hoisted_12,
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t(`generic.backupCoordinator.statusTextByType.notConfigured`)), 1),
                  _createVNode(TooltipWithShowMoreOption, {
                    value: config.value.showBackupsTooltip,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((config.value.showBackupsTooltip) = $event)),
                    "max-items-to-display": maxBackupItems,
                    "items-list": _unref(installedBackupNamesWithoutSelectedBackup)
                  }, null, 8, ["value", "items-list"]),
                  _createVNode(TooltipBtn, {
                    style: {"margin-top":"-3px"},
                    "tooltip-body-text-class": "ib-color-white",
                    "self-anchor": "top left",
                    "btn-icon": "icon-question-circle",
                    "btn-size": 7,
                    "tooltip-body-text": _ctx.$t(`generic.backupCoordinator.statusTooltip.notConfigured`)
                  }, null, 8, ["tooltip-body-text"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(showPostfixSeparator))
            ? (_openBlock(), _createBlock(_unref(IncrediLegend), {
                key: 2,
                color: _unref(STATUS_COLOR_MAP).GraySeparator,
                size: 4,
                style: {"margin":"6px 18px 0 18px"}
              }, null, 8, ["color"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})